<script lang="ts">
  import { Button } from '../common';

  let {
    selectedCount = 0,
    onEdit,
    onClearSelection
  }: {
    selectedCount: number;
    onEdit: () => void;
    onClearSelection: () => void;
  } = $props();
</script>

<div class="bulk-actions-bar">
  <span class="selection-count">{selectedCount} transaction(s) selected</span>
  <Button variant="ghost" size="sm" onclick={onEdit} class="btn-bulk-edit">Edit Selected</Button>
  <Button variant="ghost" size="sm" onclick={onClearSelection} class="btn-clear-selection">Clear Selection</Button>
</div>

<style lang="scss">
  .bulk-actions-bar {
    position: sticky;
    top: 0;
    z-index: 98;
    background: var(--color-warning);
    color: white;
    padding: var(--spacing-md) var(--spacing-lg);
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
    box-shadow: var(--shadow-md);

    .selection-count {
      font-weight: var(--font-weight-semibold);
      margin-right: auto;
    }

    :global(.btn-bulk-edit) {
      background: white !important;
      color: var(--color-warning) !important;
      border: none !important;
    }

    :global(.btn-clear-selection) {
      background: rgba(255, 255, 255, 0.2) !important;
      color: white !important;
      border: 1px solid rgba(255, 255, 255, 0.3) !important;
    }
  }
</style>
